import React from 'react';
import { BsImageFill } from 'react-icons/bs';

const MediaPreview = props => {
	const { from, margin, media } = props;
	const mediaProps = media && media.props;
	const { source } = mediaProps || {};

	const fromPreview = from === 'Preview';
	const fromButton = from === 'WidgetButton';
	const fromStandardHomescreen = from === 'nativeLayoutHelpers';
	const image = source && (source.src || source.uri);

	return image ? (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && (
					<div className="hover-container" style={{ margin: '0', borderRadius: '0' }}>
						Media
					</div>
				)}
				<img
					src={image}
					style={{
						width: '100%',
						objectFit: 'contain',
					}}
					alt={source.name}
				/>
			</div>
		</div>
	) : (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : 'media-container'}>
				{!from && (
					<div
						className="hover-container"
						style={{ borderRadius: '0', margin: fromStandardHomescreen ? 0 : '.5rem' }}
					>
						{fromStandardHomescreen
							? media.component === 'TouchableOpacity'
								? 'Image Button'
								: 'Image'
							: 'Media'}
					</div>
				)}
				<div
					className="media-preview"
					style={{
						margin,
						height: fromButton || fromPreview ? '80px' : fromStandardHomescreen ? '100%' : '160px',
						width: fromButton ? '100%' : 'auto',
						minHeight: fromButton ? '0' : '150px',
					}}
				>
					<BsImageFill style={{ fontSize: fromButton || fromPreview ? 26 : 32, color: 'white' }} />
				</div>
			</div>
		</div>
	);
};

export default MediaPreview;
